module.exports = __webpack_public_path__ + "static/img/serveone-renewal.5154449.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/serveone-renewal.jpg
// module id = rr63
// module chunks = 0